import { render, staticRenderFns } from "./EditProfileMenu.vue?vue&type=template&id=2a19548a&scoped=true"
import script from "./EditProfileMenu.vue?vue&type=script&lang=js"
export * from "./EditProfileMenu.vue?vue&type=script&lang=js"
import style0 from "./EditProfileMenu.vue?vue&type=style&index=0&id=2a19548a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a19548a",
  null
  
)

export default component.exports